const isResolvedResource = require('../contentful/is-resolved-resource');
const equipmentLevelTransformer = require('./equipmentLevel').default;
const modelTransformer = require('./model');
const variantGroupTransformer = require('./variantGroup');

const createEntryLink = (entry) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Entry',
      id: entry.id
    }
  };
};

const calculatePrice = (regFee, price) => {
  return Math.ceil(((price - regFee) / 1.25) + regFee, 10);
};

module.exports = {
  contentfulToInternal(entry) {
    // console.log("variant", entry);
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),
      contentType: null,

      name: entry.fields.name ? entry.fields.name['nb-NO'] : '',
      displayname: (entry.fields.displayname ? entry.fields.displayname['nb-NO'] : ''),
      year: (entry.fields.year ? entry.fields.year['nb-NO'] : null),
      price: (entry.fields.price ? entry.fields.price['nb-NO'] : null),
      optionCode: (entry.fields.optionCode ? entry.fields.optionCode['nb-NO'] : ''),
      fuelType: (entry.fields.fuelType ? entry.fields.fuelType['nb-NO'] : ''),

      model: null,
      equipmentLevel: null,
      variantGroup: null,

      modelCode: (entry.fields.modelCode ? entry.fields.modelCode['nb-NO'] : ''),
      optionDescription: (entry.fields.optionDescription ? entry.fields.optionDescription['nb-NO'] : ''),
      vehicleClass: (entry.fields.vehicleClass ? entry.fields.vehicleClass['nb-NO'] : null),
      vehicleGroup: (entry.fields.vehicleGroup ? entry.fields.vehicleGroup['nb-NO'] : ''),
      gearbox: (entry.fields.gearbox ? entry.fields.gearbox['nb-NO'] : 'Unknown'),
      poweredAxles: (entry.fields.poweredAxles ? entry.fields.poweredAxles['nb-NO'] : null),
      engineVolume: (entry.fields.engineVolume ? entry.fields.engineVolume['nb-NO'] : null),
      engineVolumeManual: (entry.fields.engineVolumeManual ? entry.fields.engineVolumeManual['nb-NO'] : null),
      engineHorsepower: (entry.fields.engineHorsepower ? entry.fields.engineHorsepower['nb-NO'] : null),
      fuelConsumption: (entry.fields.fuelConsumption ? entry.fields.fuelConsumption['nb-NO'] : null),
      numberOfSeats: (entry.fields.numberOfSeats ? entry.fields.numberOfSeats['nb-NO'] : null),
      cargoLengthHeightCode: (entry.fields.cargoLengthHeightCode ? entry.fields.cargoLengthHeightCode['nb-NO'] : null),
      variantDescription: (entry.fields.variantDescription ? entry.fields.variantDescription['nb-NO'] : null),
      regFee: (entry.fields.regFee ? entry.fields.regFee['nb-NO'] : null),
      wltp: (entry.fields.wltp ? entry.fields.wltp['nb-NO'] : null),
      batterySizeGross: (entry.fields.batterySizeGross ? entry.fields.batterySizeGross['nb-NO'] : null),
      batterySizeNet: (entry.fields.batterySizeNet ? entry.fields.batterySizeNet['nb-NO'] : null),

      deactivatedText: (entry.fields.deactivatedText ? entry.fields.deactivatedText['nb-NO'] : ''),

      custom: (entry.fields.custom ? entry.fields.custom['nb-NO'] : null)
    };

    if (entry.sys && entry.sys.contentType) {
      result.contentType = entry.sys.contentType.sys.id;
    }

    // Handle equipment level link:
    if (entry.fields.equipmentLevel && entry.fields.equipmentLevel['nb-NO'] && isResolvedResource(entry.fields.equipmentLevel['nb-NO'])) {
      result.equipmentLevel = equipmentLevelTransformer.contentfulToInternal(entry.fields.equipmentLevel['nb-NO']);
    }

    // Handle model link:
    if (entry.fields.model && entry.fields.model['nb-NO'] && isResolvedResource(entry.fields.model['nb-NO'])) {
      result.model = modelTransformer.contentfulToInternal(entry.fields.model['nb-NO']);
    }

    if (result.regFee) {
      result.rawPrice = result.price;
      result.price = calculatePrice(result.regFee, result.price);
    }

    // Handle variant group link:
    if (entry.fields.variantGroup && entry.fields.variantGroup['nb-NO'] && isResolvedResource(entry.fields.variantGroup['nb-NO'])) {
      result.variantGroup = variantGroupTransformer.contentfulToInternal(entry.fields.variantGroup['nb-NO']);
    }

    return result;
  },

  internalToContentful(variant) {
    const result = {
      fields: {
        displayname: {
          'nb-NO': variant.displayname
        },
        engineVolumeManual: {
          'nb-NO': parseInt(variant.engineVolumeManual, 10)
        },
        variantDescription: null,
        variantGroup: null,
        regFee: null,
        deactivatedText: null,
        wltp: {
          'nb-NO': variant.wltp ? parseInt(variant.wltp, 10) : null
        },
        batterySizeGross: {
          'nb-NO': variant.batterySizeGross ? parseFloat(variant.batterySizeGross) : null
        },
        batterySizeNet: {
          'nb-NO': variant.batterySizeNet ? parseFloat(variant.batterySizeNet) : null
        }
      }
    };

    if (variant.variantGroup) {
      result.fields.variantGroup = {
        'nb-NO': createEntryLink(variant.variantGroup)
      };
    }
    if (variant.variantDescription) {
      result.fields.variantDescription = {
        'nb-NO': variant.variantDescription
      };
    }
    if (variant.regFee) {
      result.fields.regFee = {
        'nb-NO': parseInt(variant.regFee, 10)
      };
    }
    if (variant.deactivatedText) {
      result.fields.deactivatedText = {
        'nb-NO': variant.deactivatedText
      };
    }

    if (variant.custom) {
      result.fields.custom = {
        'nb-NO': true
      };


      if (variant.equipmentLevel) {
        result.fields.equipmentLevel = {
          'nb-NO': createEntryLink(variant.equipmentLevel)
        };
      }
      result.fields.name = {
        'nb-NO': variant.name
      };
      result.fields.modelCode = {
        'nb-NO': variant.modelCode
      };
      result.fields.year = {
        'nb-NO': variant.year !== undefined ? parseInt(variant.year, 10) : null
      };
      result.fields.price = {
        'nb-NO': variant.price !== undefined ? parseInt(variant.price, 10) : null
      };
      result.fields.optionCode = {
        'nb-NO': variant.optionCode
      };
      result.fields.optionDescription = {
        'nb-NO': variant.optionDescription
      };
      result.fields.vehicleClass = {
        'nb-NO': variant.vehicleClass !== undefined ? parseInt(variant.vehicleClass, 10) : null
      };
      result.fields.cargoLengthHeightCode = {
        'nb-NO': variant.cargoLengthHeightCode
      };
      result.fields.vehicleGroup = {
        'nb-NO': variant.vehicleGroup
      };
      result.fields.numberOfSeats = {
        'nb-NO': variant.numberOfSeats !== undefined ? parseInt(variant.numberOfSeats, 10) : null
      };
      result.fields.poweredAxles = {
        'nb-NO': variant.poweredAxles !== undefined ? parseInt(variant.poweredAxles, 10) : null
      };
      result.fields.engineVolume = {
        'nb-NO': variant.engineVolume !== undefined ? parseInt(variant.engineVolume, 10) : null
      };
      result.fields.engineHorsepower = {
        'nb-NO': variant.engineHorsepower !== undefined ? parseInt(variant.engineHorsepower, 10) : null
      };
      result.fields.fuelConsumption = {
        'nb-NO': variant.fuelConsumption !== undefined ? parseInt(variant.fuelConsumption, 10) : null
      };
      result.fields.gearbox = {
        'nb-NO': variant.gearbox
      };
      result.fields.fuelType = {
        'nb-NO': variant.fuelType
      };

      if (variant.modelId) {
        result.fields.model = {
          'nb-NO': createEntryLink({id: variant.modelId}, 'Entry')
        };
      }
    }

    return result;
  },
  calculatePrice
};
